import React from 'react';
import { Link } from 'react-router-dom';

export default function TermsOfService() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--cream)', fontFamily: 'DM Sans, sans-serif', color: 'var(--text-dark)' }}>
      <div style={{ maxWidth: 760, margin: '0 auto', padding: '48px 24px 80px' }}>

        <div style={{ marginBottom: 40 }}>
          <Link to="/login" style={{ color: 'var(--sage)', textDecoration: 'none', fontSize: 14 }}>← Back to login</Link>
        </div>

        <h1 style={{ fontFamily: 'Lora, serif', fontSize: 32, fontWeight: 700, marginBottom: 8, color: 'var(--text-dark)' }}>
          Terms of Service
        </h1>
        <p style={{ color: 'var(--text-soft)', fontSize: 14, marginBottom: 40 }}>Last updated: May 15, 2026</p>

        <Section title="Agreement to Terms">
          <p>By accessing or using Transformation Companion ("the Service"), you agree to be bound by these Terms of Service. If you do not agree, do not use the Service.</p>
          <p>These terms apply to coaches, practitioners, and any other users who create an account ("you" or "Coach").</p>
        </Section>

        <Section title="Description of Service">
          <p>Transformation Companion is a practice management tool for coaches and practitioners. It provides tools for managing client records, recording and summarizing sessions using AI, exchanging messages with clients, and importing session recordings from Zoom.</p>
          <p>The Service is currently in beta. Features may change, and availability is not guaranteed.</p>
        </Section>

        <Section title="Eligibility">
          <p>You must be at least 18 years old and a practicing coach, therapist, or similar professional to use this Service. The Service is not intended for use by clients directly — clients access a limited portal only at the invitation of their coach.</p>
        </Section>

        <Section title="Coach Responsibilities">
          <p>As a Coach using this Service, you are responsible for:</p>
          <ul style={{ paddingLeft: 20, lineHeight: 2 }}>
            <li>Obtaining appropriate informed consent from your clients before entering their information into the Service, including consent for AI processing of session content</li>
            <li>Ensuring your use of the Service complies with applicable laws in your jurisdiction, including privacy laws and professional licensing requirements</li>
            <li>Maintaining the confidentiality of your account credentials</li>
            <li>All content you enter into the Service, including client records and session transcripts</li>
            <li>Determining whether this Service is appropriate for your practice given its current compliance status (see HIPAA notice below)</li>
          </ul>
        </Section>

        <Section title="HIPAA Notice">
          <div style={{ background: '#FFF8F0', border: '1px solid var(--gold)', borderRadius: 8, padding: '16px 20px' }}>
            <p style={{ margin: 0, color: 'var(--text-dark)' }}>
              <strong>Transformation Companion is not currently HIPAA-compliant.</strong> We do not execute Business Associate Agreements (BAAs). Coaches who are covered entities or business associates under HIPAA must not use this Service to store or process protected health information (PHI) until HIPAA-compliant infrastructure is in place.
            </p>
          </div>
        </Section>

        <Section title="Not a Clinical or Therapeutic Tool">
          <p>Transformation Companion is a practice management and productivity tool. The AI-generated content produced by this Service (summaries, insights, psychological profiles) is intended as a support aid for qualified practitioners only. It does not constitute clinical assessment, diagnosis, or treatment recommendations, and should never be used as a substitute for professional judgment.</p>
          <p>We make no representations about the clinical accuracy of AI-generated content.</p>
        </Section>

        <Section title="Acceptable Use">
          <p>You agree not to:</p>
          <ul style={{ paddingLeft: 20, lineHeight: 2 }}>
            <li>Use the Service for any unlawful purpose or in violation of professional ethical standards</li>
            <li>Share your account credentials with others</li>
            <li>Attempt to access other coaches' data</li>
            <li>Reverse-engineer, scrape, or otherwise extract data or code from the Service</li>
            <li>Use the Service to store information about minors without appropriate safeguards and consent</li>
            <li>Misrepresent your identity or professional qualifications</li>
          </ul>
        </Section>

        <Section title="AI-Generated Content">
          <p>The Service uses Anthropic Claude to generate session summaries, client insights, and other content. This content is generated automatically and may contain errors or inaccuracies. You are responsible for reviewing all AI-generated content before sharing it with clients or using it to inform professional decisions.</p>
          <p>We do not use your session data or client information to train AI models.</p>
        </Section>

        <Section title="Zoom Integration">
          <p>If you connect Zoom to the Service, you authorize us to receive webhook notifications from Zoom about your cloud recordings. You are responsible for ensuring you have appropriate rights and permissions to process recordings of your sessions, including consent from participants where required by law.</p>
        </Section>

        <Section title="Intellectual Property">
          <p>You retain ownership of all content you enter into the Service (client records, session notes, transcripts). You grant us a limited license to store and process this content solely to provide the Service to you.</p>
          <p>The Transformation Companion application, including its design, code, and AI prompts, is our intellectual property.</p>
        </Section>

        <Section title="Disclaimer of Warranties">
          <p>The Service is provided "as is" and "as available" without warranties of any kind, express or implied. We do not warrant that the Service will be uninterrupted, error-free, or free of security vulnerabilities. Use the Service at your own risk.</p>
        </Section>

        <Section title="Limitation of Liability">
          <p>To the maximum extent permitted by applicable law, we shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Service, including but not limited to data loss, unauthorized access to your data, or reliance on AI-generated content.</p>
          <p>Our total liability to you for any claim arising from use of the Service shall not exceed the amount you paid us in the 12 months preceding the claim (or $100 if you have not paid).</p>
        </Section>

        <Section title="Termination">
          <p>You may stop using the Service at any time. We reserve the right to suspend or terminate accounts that violate these Terms or that have been inactive for an extended period, with reasonable notice where possible.</p>
          <p>Upon termination, you may request a copy of your data. We will delete your data within 90 days of account closure.</p>
        </Section>

        <Section title="Changes to These Terms">
          <p>We may update these Terms from time to time. We will notify registered coaches by email when material changes are made. Continued use of the Service after the effective date of changes constitutes acceptance of the updated Terms.</p>
        </Section>

        <Section title="Governing Law">
          <p>These Terms are governed by the laws of the United States. Any disputes will be resolved in good faith through direct communication before pursuing formal legal remedies.</p>
        </Section>

        <Section title="Contact">
          <p>Questions about these Terms? Contact us at: <a href="mailto:stevo2012@gmail.com" style={{ color: 'var(--sage)' }}>stevo2012@gmail.com</a></p>
        </Section>

        <div style={{ marginTop: 48, paddingTop: 24, borderTop: '1px solid var(--border-light, #eee)', display: 'flex', gap: 24 }}>
          <Link to="/privacy" style={{ color: 'var(--sage)', textDecoration: 'none', fontSize: 14 }}>Privacy Policy</Link>
          <Link to="/login" style={{ color: 'var(--text-soft)', textDecoration: 'none', fontSize: 14 }}>Back to login</Link>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 36 }}>
      <h2 style={{ fontFamily: 'Lora, serif', fontSize: 20, fontWeight: 700, marginBottom: 12, color: 'var(--text-dark)' }}>{title}</h2>
      <div style={{ lineHeight: 1.75, color: 'var(--text-mid)', fontSize: 15 }}>
        {children}
      </div>
    </div>
  );
}
